<template>
  <div style="width: 1200px; margin: 0 auto">
    <div class="toTop" @click="toTop">⬆</div>
    <!--頭部banner-->
    <div style="margin: 0 auto">
      <div class="secondPageBanner"><img :src="seriesImg" alt="" v-show="seriesImg"></div>
    </div>

    <!--篩選條件-->
    <div class="selectedPage">

      <div class="selectedTitle">
        <router-link :to="{ name:'JewelleryHome' }"><span>
            {{ $t('mall_home.jewellery_box') }}<!-- 搜飾盒 -->
        </span></router-link>
        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
        <router-link :to="{ name:'Search', query: { type: 'RECO' } }"><span>
           {{ $t('mall_home.fine_jewellery') }}<!-- 珠寶首飾 -->
        </span></router-link>
        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
        <span class="selectItem">{{ title }}</span>
      </div>
      <div class="divider"></div>

      <div class="selectCondition">
        <div :hidden="nonSort">
          <div class="selectConditionBox">
            <div class="conditionBoxL">
              <div class="conditionBox">
                <div v-for="item in filterList"
                     class="conditionItem"
                     :class="{'activeColor': index === item && isShow}"
                     @mouseenter="enter(item)"
                     @mouseleave="leave">
                  <span>{{ item.state }}</span>
                  <img :src="require('@/assets/homeImg/home_icon_xjt@2x.png')" alt="">
                  <transition name="fade">
                    <div class="conditionContent"
                         v-show="index === item ? isShow:false"
                         :index="item">
                      <ul class="classify" v-for="(row,index) in item.extra" :key="index">
                        <li @click="chooseMaterial(row, item)">{{ row.name }}</li>
                      </ul>
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <div class="conditionBoxR">
              <div>
                <span>
                  <!-- 排序方式 -->
                  {{ $t('mall_search.sort_by') }}：</span>
                <div class="priceSort">
                  <el-select v-model="sortIndex"
                             :placeholder="$t('mall_search.low_2_high')"
                             @change="changeSort(sortIndex)"
                             size="small">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

          </div>

          <!--          <div class="selectAll">-->
          <!--            <div class="selectAllTitle" style="padding: 5px 0">已選：</div>-->
          <!--            <div class="selectAllBox">-->
          <!--              &lt;!&ndash;<transition name="fade">&ndash;&gt;-->
          <!--              <div class="selectAllItems" v-for="(item,index) in chooseBox" :key="index">-->
          <!--                <div>{{item.name}}</div>-->
          <!--                <div>-->
          <!--                  <span class="selectLine"></span>-->
          <!--                  <img @click="remove(index)" :src="require('@/assets/homeImg/ssjg_icon_close@2x.png')" alt="">-->
          <!--                </div>-->

          <!--              </div>-->
          <!--              &lt;!&ndash;</transition>&ndash;&gt;-->
          <!--            </div>-->
          <!--            <div class="clearAll" @click="clearAll" style="padding: 5px 0">清除篩選</div>-->
          <!--          </div>-->
        </div>


        <div>

          <div class="infinite-list-wrapper" style="overflow:auto;width: 100%;">
            <ul class="list resultBox">
              <li v-for="product in productLists" class="list-item resultItem">
                <div class="product" style="height: 100%;">
                  <div class="resultImg">
                    <span v-show="product.is_new" class="is_new">
                      {{ $t('mall_search.new') }}<!-- 新品 -->
                    </span>
                    <!--<img class="is_favorite" @click="favorite(product)" :src="product.is_favorite ? require('@/assets/img/product_list/favorite_on.png') : require('@/assets/img/product_list/favorite_off.png')">-->
                    <img class="product_img" :src="imgUrl + product.product_model.path" alt=""
                         @click="routerTo({name:'Product', query:{id:product.product_model_id}})">
                  </div>
                  <div class="resultContent">
                    <div class="resultName">{{ product.product_model.default_name }}</div>
                    <div class="resultPrice">${{ product.price | PriceFormat }}</div>
                    <div class="addCart" @click="routerTo({name:'Product', query:{id:product.product_model_id}})">
                      {{ $t('mall_search.buy') }}<!-- 立即購買 -->
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <p v-if="loading" style="text-align: center;">
              {{ $t('mall_search.loading') }}<!-- 加載中... -->
            </p>
            <p v-if="noMore" style="text-align: center;">
              {{ $t('mall_search.no_more') }}<!-- 沒有更多了 -->
            </p>
          </div>

        </div>
      </div>

    </div>

    <div style="margin-bottom: 60px"></div>
  </div>
</template>

<script>
import PriceFormat from '@/assets/js/PriceFormat';
import baseUrl from '@/api/baseUrl.js'

export default {
  name: "Search",
  props: ['series', 'search'],
  data() {
    return {
      nonSort: false,
      seriesImg: '',
      area: process.env.AREA,
      imgUrl: baseUrl.imgUrl,
      isShow: false,
      index: 0,
      isActive: '',
      options: [{
        value: 'sell_price asc',
        label: this.$t('mall_search.low_2_high')
      }, {
        value: 'sell_price desc',
        label: this.$t('mall_search.high_2_low')
      },],
      sortIndex: '',
      productLists: [],
      loading: false,
      noMore: false,
      chooseBox: [],
      title: this.$t('mall_home.all_product'),
      type: 'rg',
      filterList: [],
      params: {
        count: 15,
        page: 1,
        sort_by: 'created_at',
        sort_direction: 'desc',
        product_type: [this.type],
        promotion_type: [],
        price: [],
        diamond_shape: [],
        gem_category: [],
        mosaic_mode: [],
        arm_guard: [],
        classification: [],
        scene: [],
        diamond_weight: [],
        series: 0,
      }
    }
  },
  computed: {
    disabled() {
      return this.loading || this.noMore
    }
  },
  filters: {
    PriceFormat(val) {
      return PriceFormat(val);
    }
  },
  methods: {
    routerTo(params) {
      let routeData = this.$router.resolve(params);
      window.open(routeData.href, '_blank');
    },
    changeSort(sortIndex) {
      var sort = sortIndex.split(' ')
      this.params.sort_by = sort[0];
      this.params.sort_direction = sort[1];
      this.pageFirst();
    },
    enter(item) {
      this.index = item;
      this.isShow = true
    },
    leave() {
      this.isShow = false
    },
    showCondition(item) {
      this.index = item;
      console.log(this.index);
      this.isShow = !this.isShow
    },
    chooseMaterial(row, item) {
      this.isShow = false;
      if (!this.chooseBox.includes(row)) {
        row.type = item.filter_name;
        if (item.is_multiple === 'n') {
          this.chooseBox.forEach((obj, index) => {
            if (obj.type === row.type) {
              this.chooseBox.splice(index, 1);
              this.params[row.type] = [];
            }
          });
        }
        this.chooseBox.push(row);
        this.params[row.type].push(row.id);
        this.pageFirst();
      }
    },
    pageFirst() {
      this.noMore = false;
      this.params.page = 1;
      this.getData('reset');
    },
    remove(index) {
      var paramsIndex = this.params[this.chooseBox[index].type].indexOf(this.chooseBox[index].id);
      this.params[this.chooseBox[index].type].splice(paramsIndex, 1);
      this.chooseBox.splice(index, 1);
      this.pageFirst();
    },
    filterReset() {
      this.params = {
        count: 15,
        page: 1,
        sort_by: this.params.sort_by,
        sort_direction: this.params.sort_direction,
        product_type: this.params.product_type,
        promotion_type: this.params.promotion_type,
        price: [],
        // product_type: [],
        diamond_shape: [],
        gem_category: [],
        mosaic_mode: [],
        arm_guard: [],
        classification: [],
        scene: [],
        diamond_weight: [],
        series: this.params.series,
      }
    },
    clearAll() {
      if (this.chooseBox.length > 0) {
        this.chooseBox = [];
        this.filterReset();
        this.pageFirst();
      }
    },
    handleScroll() {
      this.nextPage();
    },
    favorite(product) {
      product.is_favorite = !product.is_favorite;
      this.$notify({
        title: product.is_favorite
          ? this.$t('mall_search.collected')
          : this.$t('mall_search.collection_cancel'),
        type: 'success',
        duration: 2000
      });
    },
    toTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 280;
    },
    nextPage() {
      if (!this.loading && !this.noMore) {
        let wh = $(window).height();
        let ot = $(".resultBox").offset().top;
        let ds = $(document.documentElement).scrollTop();
        if (ds > wh) {
          $(".toTop").show();
          $(".toTop").css('opacity', 0.6);
        } else {
          $(".toTop").hide();
          $(".toTop").css('opacity', 0);
        }
        let resultBox_h = $(".resultBox").height();
        let bh = wh - resultBox_h - (ot - ds);
        if (bh > -100) {
          this.params.page += 1;
          this.getData();
        }
      }
    },
    getData(resetPage = false) {
      this.loading = true;
      if (this.$route.query.search) {
        this.nonSort = true;
        this.$axios.get('api/app_v1/search_product_models?search_key=' + this.$route.query.search + '&page=' + this.params.page, {}).then(res => {
          if (resetPage) {
            this.productLists = res.data.data;
          } else {
            this.productLists = this.productLists.concat(res.data.data)
          }
          if (res.data.data.length < 1) {
            this.noMore = true;
          }
          this.loading = false;
        });
      } else {
        this.$axios.post('api/app_v1/for_ssh/product_filter', this.params).then(res => {
          if (resetPage) {
            this.productLists = res.data.data;
          } else {
            this.productLists = this.productLists.concat(res.data.data)
          }
          if (res.data.data.length < 1) {
            this.noMore = true;
          }
          this.loading = false;
        });
      }

    },
    getBannerImg() {

      if (this.type.indexOf('series') > -1) {
        let seriesId = this.type.split('series')[1];
        // console.log("type:  =====seriesId=====", seriesId);
        if (seriesId == 39) {
          // 婚戒&对戒
          this.title = this.$t('mall_home.w_ring')
          this.seriesImg = this.imgUrl + 'banner/banner_Wedding_ring.jpg';
        } else if (seriesId == 40) {
          //男士珠宝
          this.title = this.$t('mall_home.mens')
          this.seriesImg = this.imgUrl + 'banner/banner_Mens_jewelry.jpg';
        } else {
          for (let key in this.series.series) {
            console.log("this.series.series[key].id", this.series.series[key].id)
            if (this.series.series[key].id == seriesId) {
              if (this.$i18n.locale === 'en') {
                this.seriesImg = this.imgUrl + this.series.series[key].path_en;
              } else {
                this.seriesImg = this.imgUrl + this.series.series[key].path;
              }
              console.log("type:  ========key", key + '   img:  ' + this.seriesImg);
              this.title = this.series.series[key].title;
              return
            }}

        }
      } else {
        let type = this.$route.query.type;
        console.log('this.$route.query.type======>', type);
        //综合筛选
        if (type == 'reco') {
          this.seriesImg = this.imgUrl + 'banner/banner_comprehensive.jpg';
        }
        for (let key in this.series.product_types) {
          if (this.series.product_types[key].code == type.toUpperCase()) {
            this.seriesImg = this.imgUrl + this.series.product_types[key].path;
            this.title = this.series.product_types[key].title;
          }
        }
      }
    },
    getFilters() {
      this.$axios.get('mall_api/filters', {'product_type': this.params.product_type}).then(res => {
        this.filterList = res.data.data;
      });
    },
    typeHandle() {
      this.type = this.$route.query.type.toLowerCase();
      if (this.type.indexOf('_') > -1) {
        this.params.product_type = this.type.split('_');
      } else {
        this.params.product_type = [this.type.toUpperCase()];
      }
    }
  },
  watch: {
    series: function () {
      this.getBannerImg();
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  created() {
    this.typeHandle();
    // this.getBannerImg();
    this.getFilters();
    this.getData();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true);   //  離開頁面清除（移除）滾輪滾動事件
  },
}
</script>

<style scoped>
.secondPageBanner > img {
  width: 1200px;
  max-height: 480px;
}

.selectedTitle {
  width: 1000px;
  margin: 0 auto;
  /*padding-left: 100px;*/
  /*padding-right: 100px;*/
}

.divider {
  margin: 0 100px;
  height: 1px;
  background-color: #ddd;
}

.selectCondition {
  padding: 0 100px;
  /*position: relative;*/
}

.selectConditionBox {
  border-bottom: 1px solid #ddd;
  padding: 20px 0;
  position: relative;
  display: flex;
}

.conditionBox {
  cursor: default;
}

.selectAll {
  color: #565554;
  font-size: 14px;
  margin-top: 15px;
}

.selectAll > div {
  float: left;
}

.selectAllTitle {
  color: #979694;
}

.selectAll > .selectAllBox {
  height: 28px;
}

.selectAllItems {
  float: left;
  height: 28px;
  border: 1px solid #ddd;
  margin-right: 10px;
}

.selectAllItems div {
  display: inline-block;
  height: 28px;
}

.selectAllItems div:first-child {
  white-space: nowrap;
  text-align: center;
  cursor: default;
  padding: 4px 8px;
  float: left;
}

.selectAllItems div:last-child .selectLine {
  display: inline-block;
  width: 1px;
  height: 24px;
  background-color: #ddd;
  margin: 2px 0;
}

.selectAllItems div:last-child > img {
  width: 14px;
  height: 14px;
  padding: 7px 7px 7px 3px;
  cursor: pointer;
}

.clearAll {
  cursor: pointer;
  margin-left: 15px;
  color: #BBA16B;
}

.clearAll:hover {
  opacity: 0.7;
}

.conditionItem {
  color: #1E1303;
  font-size: 16px;
  display: inline-block;
  padding-right: 30px;
}

.activeColor {
  color: #BBA16B;
}

.conditionBoxL {
  flex: 1;
}

.conditionBoxL .conditionBox {
  padding: 5px 0;
}

.conditionItem > img {
  position: relative;
  top: -2px;
  width: 9px;
  height: 5px;
}

.conditionBoxR {
  font-size: 16px;
  color: #5B5957;
  text-align: right;
  width: 300px;
}

.conditionBoxR > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.priceSort {
  position: relative;
  width: 207px;
  /*height: 35px;*/
}

.priceSort > input {
  width: 207px;
  height: 30px;
  border: 1px solid #bbb;
  padding-left: 10px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.priceSort > img {
  width: 12px;
  height: 6px;
  position: absolute;
  top: 50%;
  margin-top: -3px;
  right: 10px;
}

.conditionContent {
  position: absolute;
  top: 50px;
  width: 100%;
  box-sizing: border-box;
  left: 0;
  /*width: 84%;*/
  height: 150px;
  border: 1px solid rgba(30, 19, 3, 0.1);
  background-color: #fff;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
  z-index: 999;
  /*background-color: #f00;*/
  /*display: block;*/
}

.classify > li {
  float: left;
  color: #5B5957;
  font-size: 14px;
  padding: 5px;
  margin: 5px;
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.resultBox {
  /*min-height: 100px;*/
  text-align: center;
  overflow: hidden;
  margin-top: 30px;
  /*max-height: 800px;*/
  /*overflow-y: scroll;*/
  /*box-shadow: 0 0 5px 0 rgba(0,0,0,.1);*/
}

.resultItem {
  float: left;
  margin: 0 auto;
  flex: 1;
  width: 33.33%;
  height: 420px;
  background-color: white;
  /*margin: 0 auto;*/
  padding: 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  color: #31302F;
  font-size: 14px;
}

.resultItem:nth-child(3n) {
  margin-right: 0;
}

.resultImg {
  width: 70%;
  margin: 0 auto;
  text-align: center;
  padding-top: 30px;
  position: relative;
}

.resultItem > div {
  text-align: center;
  /*box-shadow: 5px 5px 5px 0 rgba(0,0,0,.1);*/
}

.product_img {
  width: 100%;
}

.resultContent {
  position: relative;
  padding-top: 20px;
  left: 50%;
  width: 100%;
  margin-left: -50%;
  cursor: default;
  /*margin-left: ;*/
}

.resultPrice {
  color: #1E1303;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 5px;
}

.addCart {
  background-color: #1E1303;
  color: #fff;
  width: 96px;
  margin: 0 auto;
  padding: 4px 0;
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  border-radius: 1px;
  margin-bottom: 20px;
}

.is_new {
  opacity: 0.8;
  cursor: default;
  position: absolute;
  text-align: center;
  color: #d0b377;
  width: 57px;
  font-weight: 900;
  border: 2px solid #d0b377;
}

.is_favorite {
  position: absolute;
  width: 21px;
  right: 0;
  padding: 3px;
  /*cursor: pointer;*/
}

.is_favorite:hover {
  opacity: 0.8;
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

.product {
  box-sizing: border-box;
  border-bottom: 2px solid #DDDDDD;
  transition: border-bottom-color, border-bottom-width .1s;
}

.product:hover {
  border-bottom: 8px solid #BAA069;
  transition: border-bottom-color, border-bottom-width .1s;
}

.toTop {
  line-height: 1.3;
  color: #1E1303;
  width: 50px;
  height: 50px;
  text-align: center;
  border: 5px solid #1E1303;
  border-radius: 50px;
  position: fixed;
  bottom: 0;
  right: 0;
  font-size: 40px;
  margin: 50px;
  z-index: 8;
  opacity: 0;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/viewHK/Search.vue